export default __webpack_public_path__ + "static/13-1255420a53f55d31025a52a6668fe662.jpg";